import React from 'react';
import CardSection from '../../Shared/CardSection';
import PolicyValueChart from '../Charts/PolicyValueChart';

const AnnuityFIAValuesSection = ({ model, portalSettings }) => {

    const {
        box1Label,
        box1Value,
        box2Label,
        box2Value,
        box3Label,
        box3Value,
        policyYearInterest,
        withdrawalCharge,
        mva,
        penaltyFreeAmount,
        premBonus,
        premBonusRecap,
        lastPaid,
        totalInterestEarned
    } = model.annuityFIAValues;

    const {
        productName,
        productType,
        issueDate,
        termDate,
        qualType,
        premiumSum,
        anniversaryDate
    } = model.policyInfo;

    const wcInfo = "Surrender Charges apply to full or partial surrenders in excess of the Free Partial Surrender Amount during a Multi - Year Interest Rate Guarantee Period. The surrender Charge is equal to a percentage of the Accumulation Value surrendered according to the table of Surrender Charge Percentages shown in the Contract Schedule. The Surrender Charge percentage varies based on the amount of time elapsed since the beginning of the current Multi - Year Interest Rate Guarantee Period.";
    const mvaInfo = "An increase or decrease in withdrawal amounts based on the movement of interest rates. This only applies when withdrawal charges apply.";
    const pfaInfo = "The amount you can withdraw without penalty charges.";

    const cleanValue = rawValue => {
        if (rawValue == null) return 0;
        // Remove $ and commas & then parse
        const numeric = parseFloat(rawValue.toString().replace(/[$,]/g, ""));
        return isNaN(numeric) ? 0 : numeric;
    };

    const myChartData = [
        { label: "Premiums", value: cleanValue(premiumSum) },
        { label: "Interest", value: cleanValue(totalInterestEarned) },
        { label: "Premium Bonus", value: cleanValue(premBonus) },
    ];

    return (
        <div className="container container-section custom-width" id="values-container">
            {/* Top Row: Summary Cards */}
            <div className="flex-row">
                {[
                    { label: box1Label, value: box1Value },
                    { label: box2Label, value: box2Value },
                    { label: box3Label, value: box3Value }
                ].map(({ label, value }, idx) => (
                    <div key={idx} className="policy-card small-card">
                        <div className="card">
                            <div className="card-body">
                                <h6>{label}</h6>
                                <h3 className="bold value">{value}</h3>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Second Row: Card Sections */}
            <div className="flex-row">
                {/* Value Details with Chart */}
                <div className="policy-card large-card">
                    <div className="card">
                        <div className="card-header large-card-header">
                            <h6>Value Details</h6>
                        </div>
                        <div className="card-body">
                            <PolicyValueChart chartData={myChartData} portalSettings={portalSettings} />
                        </div>
                    </div>
                </div>

                {/* Cash Surrender Value Info */}
                <CardSection
                    title="Cash Surrender Value"
                    blocks={[
                        { label: "Withdrawal Charge:", value: withdrawalCharge, info: wcInfo },
                        { label: "MVA:", value: mva, info: mvaInfo },
                        { label: "Penalty Free Amount:", value: penaltyFreeAmount, info: pfaInfo },
                        { label: "Premium Bonus Recap:", value: premBonusRecap }
                    ]}
                />

                {/* Contract Details */}
                <CardSection
                    title="Contract Details"
                    blocks={[
                        { label: "Product:", value: productName },
                        { label: "Product Type:", value: productType },
                        { label: "Issue Date:", value: issueDate },
                        { label: "Anniversary Date:", value: anniversaryDate },
                        { label: "Tax Qualification:", value: qualType }
                    ]}
                />
            </div>
            <div className="flex-row">**Values as of {lastPaid}**</div>
        </div>
    );
};

export default AnnuityFIAValuesSection;
